<template>
  <v-app
    :class="{
      'workspace-dashboard': $route.path === '/Dashboard',
      'workspace-checkin': $route.path.startsWith('/CheckinMeeting'),
      'workspace-compact':
        $route.path === '/Dashboard' ||
        $route.path === '/TransactionRoomBooking' ||
        $route.path === '/Facility' ||
        $route.path === '/Zone' ||
        $route.path === '/Utility' ||
        $route.path === '/Location' ||
        $route.path === '/Roompad' ||
        $route.path === '/ManageUser' ||
        $route.path === '/ManageRole' ||
        $route.path.startsWith('/ManageOrder') ||
        $route.path === '/ViewSchedule',
      'workspace-list-compact':
        $route.path === '/TransactionRoomBooking' ||
        $route.path === '/Facility' ||
        $route.path === '/Zone' ||
        $route.path === '/Utility' ||
        $route.path === '/Location' ||
        $route.path === '/Roompad' ||
        $route.path === '/ManageUser' ||
        $route.path === '/ManageRole' ||
        $route.path.startsWith('/ManageOrder') ||
        $route.path === '/ViewSchedule',
    }"
  >
    <GlobalNavigation
      v-if="showGlobalNavigation"
      :updated-at="pageUpdatedAt"
      @navigation-toggle="navExpanded = $event"
    />
    <v-content
      :class="{
        'with-global-navigation': showGlobalNavigation,
        'navigation-collapsed': showGlobalNavigation && !navExpanded,
      }"
    >
      <div id="grad" class="route-content" v-if="$route.path == '/MainMenu'">
        <router-view @data-updated="onPageDataUpdated"></router-view>
      </div>
      <div v-else class="route-content">
        <router-view @data-updated="onPageDataUpdated"></router-view>
      </div>
    </v-content>
    <!-- <Footer
      v-if="
        $route.path != '/MeetingRoomScreen' &&
        $route.path != '/Order' &&
        $route.path != '/MyOrder' &&
        $route.path != '/AllBooking' &&
        !$route.path.startsWith('/CheckinMeeting')
      "
    /> -->
  </v-app>
</template>

<script>
import GlobalNavigation from "./components/GlobalNavigation";
// import Footer from "./components/Footer";
export default {
  name: "App",
  data() {
    return {
      navExpanded: false,
      pageUpdatedAt: null,
    };
  },
  components: {
    GlobalNavigation,
    // Footer,
  },
  computed: {
    showGlobalNavigation() {
      return (
        this.$route.path !== "/Login" &&
        this.$route.path !== "/MeetingRoomScreen" &&
        this.$route.path !== "/ViewSchedule" &&
        this.$route.path !== "/Order" &&
        this.$route.path !== "/MyOrder" &&
        this.$route.path !== "/AllBooking" &&
        !this.$route.path.startsWith("/CheckinMeeting")
      );
    },
  },

  watch: {
    "$route.fullPath"() {
      this.pageUpdatedAt = null;
    },
  },
  methods: {
    onPageDataUpdated({ route, updatedAt }) {
      if (route !== this.$route.fullPath) return;
      const timestamp = new Date(updatedAt);
      if (!Number.isNaN(timestamp.getTime())) this.pageUpdatedAt = timestamp;
    },
  },
  mounted() {
    this.checkInterval = setInterval(() => {
      const token = this.$cookies.get("Token");
      if (token) {
        this.$store.dispatch("CheckToken", { token }).catch(() => {});
      }
    }, 60 * 1000);
  },

  beforeDestroy() {
    if (this.checkInterval) clearInterval(this.checkInterval);
  },
};
</script>

<style>
:root {
  --workspace-ui-scale: 1.25;
  --workspace-content-top: 65px;
  --workspace-content-left-expanded: 298px;
  --workspace-content-left-collapsed: 153px;
  --workspace-min-height: 1100px;
}

@font-face {
  font-family: "Inter";
  src: local("Inter"), url(./assets/Font/Inter-VariableFont_opsz,wght.ttf);
}

.v-content__wrap {
  background-color: white;
  width: 100%;
  height: auto;
  min-height: 100vh;
}

.with-global-navigation .v-content__wrap {
  box-sizing: border-box;
  width: 100%;
  max-width: 100vw;
  min-height: max(100vh, var(--workspace-min-height));
  padding: 125px 24px 40px var(--workspace-content-left-expanded);
  overflow-x: hidden;
  background: #f6f6f6;
  transition: padding-left 180ms ease-out;
}

.with-global-navigation.navigation-collapsed .v-content__wrap {
  padding-left: var(--workspace-content-left-collapsed);
}

/* Compact desktop shell is enabled route-by-route. */
@media (min-width: 701px) {
  .workspace-compact .global-navigation {
    zoom: 1;
  }

  .workspace-compact .global-navigation .global-topbar {
    height: 68px;
    padding: 0 8px 0 9px;
  }

  .workspace-compact .global-navigation .global-brand {
    width: 54px;
    height: 54px;
    flex-basis: 54px;
  }

  .workspace-compact .global-navigation .global-heading {
    margin-left: 24px;
  }

  .workspace-compact .global-navigation .global-heading h1 {
    font-size: 24px;
    line-height: 29px;
  }

  .workspace-compact .global-navigation .global-heading p {
    margin-top: 0;
    font-size: 13px;
    line-height: 16px;
  }

  .workspace-compact .global-navigation .global-language {
    width: 68px;
    height: 46px;
    font-size: 16px;
  }

  .workspace-compact .global-navigation .global-profile {
    width: 184px;
    height: 46px;
  }

  .workspace-compact .global-navigation .global-profile-avatar {
    width: 38px;
    min-width: 38px;
    max-width: 38px;
    height: 38px;
    min-height: 38px;
    max-height: 38px;
    flex-basis: 38px;
  }

  .workspace-compact .global-navigation .global-profile-avatar .v-icon {
    font-size: 28px !important;
  }

  .workspace-compact .global-navigation .global-profile span {
    margin-left: 8px;
  }

  .workspace-compact .global-navigation .global-profile strong {
    font-size: 14px;
  }

  .workspace-compact .global-navigation .global-profile .global-profile-arrow {
    width: 20px;
    height: 20px;
    flex-basis: 20px;
  }

  .workspace-compact .with-global-navigation .v-content__wrap {
    min-height: 100vh;
    padding: 104px 20px 32px 250px;
  }

  .workspace-compact .with-global-navigation.navigation-collapsed
    .v-content__wrap {
    padding-left: 116px;
  }

  /* Align the Dashboard shortcut with the toolbar and menu with the panel. */
  .workspace-list-compact
    .global-navigation
    .global-sidebar.collapsed,
  .workspace-list-compact
    .global-navigation
    .global-sidebar:not(.collapsed) {
    top: 131px;
  }

  .workspace-dashboard .global-navigation .global-sidebar.collapsed,
  .workspace-dashboard .global-navigation .global-sidebar:not(.collapsed) {
    top: calc(104px + 45px);
  }
}

.with-global-navigation .route-content {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.with-global-navigation .route-content > * {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

/* Pages must size against the remaining app-shell area, never against 100vw. */
.with-global-navigation .schedule-page > .schedule-topbar {
  display: none;
}

.with-global-navigation .schedule-page {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  min-height: var(--workspace-min-height);
  padding: 0 0 32px;
}

.with-global-navigation .schedule-page > .booking-shell {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  margin: var(--workspace-content-top) 0 0;
}

/* Wide data tables scroll inside their own panel instead of widening the page. */
.with-global-navigation .route-content .v-data-table__wrapper,
.with-global-navigation .route-content .transaction-table-wrap,
.with-global-navigation .route-content .manage-user-table-wrap {
  max-width: 100%;
  overflow-x: auto;
}

.with-global-navigation .dashboard-page > .topbar,
.with-global-navigation .dashboard-page > .sidebar {
  display: none;
}

.with-global-navigation .dashboard-page > .content {
  padding: var(--workspace-content-top) 16px 32px;
}

.workspace-dashboard .with-global-navigation .dashboard-page > .content {
  padding-top: 45px;
}

.with-global-navigation .facility-heading {
  display: none;
}

/* Keep the Transaction table inside the available viewport in both menu states. */
.with-global-navigation .transaction-table {
  min-width: 0;
}

.with-global-navigation
  .transaction-table
  .v-data-table__wrapper {
  overflow-x: auto;
}

.with-global-navigation .transaction-table table {
  width: 100%;
  min-width: 0;
}

.with-global-navigation
  .transaction-table
  .v-data-table-header
  th,
.with-global-navigation .transaction-table tbody td {
  padding-right: 8px !important;
  padding-left: 8px !important;
  overflow-wrap: anywhere;
}

.with-global-navigation
  .transaction-table
  .v-data-table-header
  th {
  white-space: normal;
  line-height: 1.15;
}

.with-global-navigation
  .transaction-table
  th:first-child,
.with-global-navigation
  .transaction-table
  td:first-child {
  width: 7%;
}

.with-global-navigation
  .transaction-table
  th:nth-child(2),
.with-global-navigation
  .transaction-table
  td:nth-child(2),
.with-global-navigation
  .transaction-table
  th:nth-child(3),
.with-global-navigation
  .transaction-table
  td:nth-child(3) {
  width: 12%;
}

.with-global-navigation
  .transaction-table
  th:nth-child(4),
.with-global-navigation
  .transaction-table
  td:nth-child(4) {
  width: 10%;
}

.with-global-navigation
  .transaction-table
  th:nth-child(5),
.with-global-navigation
  .transaction-table
  td:nth-child(5),
.with-global-navigation
  .transaction-table
  th:nth-child(6),
.with-global-navigation
  .transaction-table
  td:nth-child(6) {
  width: 11%;
}

.with-global-navigation
  .transaction-table
  th:nth-child(7),
.with-global-navigation
  .transaction-table
  td:nth-child(7),
.with-global-navigation
  .transaction-table
  th:nth-child(8),
.with-global-navigation
  .transaction-table
  td:nth-child(8),
.with-global-navigation
  .transaction-table
  th:nth-child(9),
.with-global-navigation
  .transaction-table
  td:nth-child(9) {
  width: 9%;
}

.with-global-navigation
  .transaction-table
  th:last-child,
.with-global-navigation
  .transaction-table
  td:last-child {
  width: 10%;
}

@media only screen and (max-width: 959px) {
  .v-content__wrap {
    background-color: white;
    width: 80%;
  }

  .with-global-navigation .v-content__wrap {
    width: 100%;
    padding-right: 16px;
    padding-left: var(--workspace-content-left-expanded);
  }

  .with-global-navigation.navigation-collapsed .v-content__wrap {
    padding-left: var(--workspace-content-left-collapsed);
  }

  .workspace-checkin .v-content__wrap {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .with-global-navigation .v-content__wrap {
    transition: none;
  }
}

@media only screen and (max-width: 700px) {
  :root {
    --workspace-ui-scale: 1;
    --workspace-min-height: 100vh;
  }

  .with-global-navigation .v-content__wrap,
  .with-global-navigation.navigation-collapsed .v-content__wrap {
    padding: 105px 0 32px;
  }
}
* {
  font-family: "Inter";
}

#app {
  color: #444444;
}

/* Shared pagination design for every page. */
.v-application .v-pagination {
  gap: 8px;
}

.v-application .v-pagination > li {
  margin: 0;
}

.v-application .v-pagination .v-pagination__item,
.v-application .v-pagination .v-pagination__navigation {
  width: 49px;
  min-width: 49px;
  height: 49px;
  margin: 0;
  border: 0;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.28);
  font-size: 18px;
}

.v-application .v-pagination .v-pagination__item {
  background: #f6f6f6 !important;
  color: #111111 !important;
}

.v-application .v-pagination .v-pagination__item--active {
  background: #ebf4ff !important;
  color: #111111 !important;
}

.v-application .v-pagination .v-pagination__navigation {
  background: #003f96 !important;
  color: #ffffff !important;
}

.v-application .v-pagination .v-pagination__navigation .v-icon {
  color: #ffffff !important;
}

.v-application .v-pagination button:focus-visible {
  outline: 3px solid rgba(0, 63, 150, 0.3);
  outline-offset: 2px;
}

.v-application .v-pagination .v-pagination__navigation:disabled,
.v-application
  .v-pagination
  .v-pagination__navigation--disabled {
  background: #003f96 !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.28);
  opacity: 1 !important;
}

/* Keep Vuetify's rectangular dialog wrapper from showing behind rounded cards. */
.v-dialog {
  box-shadow: none !important;
}

#grad {
    height: 200px;
    background: #78A3D4;
    background: -webkit-linear-gradient(#78A3D4, #FFF); 
    background: -o-linear-gradient(#78A3D4, #FFF);
    background: -moz-linear-gradient(#78A3D4, #FFF);
    background: linear-gradient(#78A3D4, #FFF);
}

::-webkit-scrollbar {
  display: none;
}
</style>
